import React from 'react';
import PropTypes from 'prop-types';
import {
  Map as LeafletMap,
  TileLayer,
} from 'react-leaflet';
import { AppContext } from '../../Context/AppContext';

function Map(props) {
  const { children } = props;

  return (
    <LeafletMap
      zoom={13}
      minZoom={9}
      maxZoom={14}
      {...props}
    >
      <AppContext.Consumer>
        {(context) => {
          if (!context) {
            return null;
          }

          const { variables } = context;

          if (!variables || !variables.TILESET_URL) {
            return null;
          }

          return (
            <TileLayer
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
              url={variables.TILESET_URL}
            />
          );
        }}
      </AppContext.Consumer>
      {children}
    </LeafletMap>
  );
}

Map.propTypes = {
  ...LeafletMap.propTypes,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};
Map.defaultProps = {
  children: null,
};

export default Map;



// WEBPACK FOOTER //
// ./src/Components/Map/index.jsx